import { render, staticRenderFns } from "./shortcut-sms-login.vue?vue&type=template&id=71fb7c11&scoped=true"
import script from "./shortcut-sms-login.vue?vue&type=script&lang=js"
export * from "./shortcut-sms-login.vue?vue&type=script&lang=js"
import style0 from "./shortcut-sms-login.vue?vue&type=style&index=0&id=71fb7c11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb7c11",
  null
  
)

export default component.exports